import { debounce } from './debounce'

export const hamburgerAnimate = () => {
  const navToggler = document.querySelector('.nav-toggler')
  const hamburgerMenu = document.querySelector('.hamburger-menu')
  const navbar = document.querySelector('.navbar .navigation-wrapper')
  const menu = document.querySelector('ul.menu')
  const menuCurtain = document.querySelector('.menu-container-curtain')
  const menuItems = [...menu.querySelectorAll('li')]

  navToggler.addEventListener('click', () => {
    menuItems.forEach((item) => {
      item.classList.add('max-lg:transition-all', 'max-lg:duration-300')
      item.classList.remove('transition-none')
    })
    hamburgerMenu.classList.toggle('animate')
    navToggler.classList.toggle('nav-toggler-mobile')
    menu.classList.toggle('open')
    menuCurtain.classList.toggle('show')
    document.querySelector('body').classList.toggle('block')

    window.addEventListener(
      'resize',
      debounce(function (event) {
        if (window.innerWidth > 1024) {
          hamburgerMenu.classList.remove('animate')
          navToggler.classList.remove('nav-toggler-mobile')
          navbar.classList.remove('h-full')
          menu.classList.remove('open')
          menuCurtain.classList.remove('show')
          document.querySelector('body').classList.remove('block')
          menuItems.forEach((item) => {
            item.classList.remove('max-lg:transition-all', 'max-lg:3-300')
            item.classList.add('transition-none')
          })
        }
      })
    )
  })
}
